/** aws_settings start */
import axios from "axios";

export const APIURL = process.env.REACT_APP_API_ENDPOINT;
export const AMAZON_URL = APIURL + "/credential";
var AWS = require('aws-sdk');

const amazon_keys = axios.post(`${AMAZON_URL}`,{});
const promise = new Promise((resolve, reject) => { resolve(amazon_keys); }); 
promise.then(
  async function(result) {
    AWS.config.update({
      secretAccessKey: result.data[0].access_key,
      accessKeyId: result.data[0].access_id,
      region: result.data[0].region
    });
  },
  function(err) {
    return err;
  }
);
/** aws_settings ends */

const helper_funcs = {
   get_signed_url(userid,filename) {
        let s3 = new AWS.S3();
        const url = s3.getSignedUrl('getObject', {
        Bucket: process.env.REACT_APP_MEDIA_BUCKET,
        Key: filename,
        Expires: 3600,
        })
        return url
    },

    deleteImage(image_url) {
      return new Promise((resolve, reject) => {
        const bucketInstance = new AWS.S3();
    bucketInstance.deleteObject({
          Bucket: process.env.REACT_APP_MEDIA_BUCKET || "mylinkforall-media",
          Key: image_url
        }, (err, data) => {
          if (err) reject(err);
          else resolve(data);
        });
      });
    },

    upload_specific_file(file, item) {
      var extension = file.type.split("/")[1];
      // Generate random string to prevent overwriting files uploaded at same second
      var randomStr = Math.random().toString(36).substring(7);
      var key = item.userid + "/" + Math.floor(new Date().getTime() / 1000) + "_" + randomStr + "." + extension;

      var albumBucketName = process.env.REACT_APP_MEDIA_BUCKET || "mylinkforall-media";
      var upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: albumBucketName,
          Key: key,
          Body: file,
        }
      });
      return upload;
    },

    uploadimage(e,item,id)
    {
      let formData = new FormData();
      formData.append("uploadedFiles", e.target.files[0]);
      var files = document.getElementById(id).files;
      if (!files.length) {
        return 'error';
      }
      var file = files[0];
      var extension = file.type.split("/")[1];

      var key = item.userid+"/"+Math.floor(new Date().getTime() / 1000) + "." + extension;

      var albumBucketName = process.env.REACT_APP_MEDIA_BUCKET || "mylinkforall-media";
      var upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: albumBucketName,
          Key: key,
          Body: file,
          // ACL: "public-read"
        }
      });
      return upload
    },
}

export default helper_funcs;